import { tv } from 'tailwind-variants'

import { body1, h1, h2 } from '@ui-kit/core/typography'

import './subheading.css'

export const sectionStyles = tv({
  slots: {
    container:
      'transition-transform-opacity mb-20 grid max-w-[1440px] transform scroll-mt-28 items-center px-6 duration-1000 md:px-12 lg:mb-[120px] xl:px-[120px]',
    headingContainer: 'flex flex-col',
    heading: 'mb-6',
    subheading: [body1(), 'mb-8'],
    supportingContentContainer: 'flex flex-col',
    headerCtaButton: 'mt-6 self-start max-xl:hidden',
  },
  variants: {
    inView: {
      true: {
        container: 'translate-y-0 opacity-100',
      },
      false: {
        container: 'translate-y-8 opacity-0',
      },
    },
    layout: {
      header: {
        container: 'flex-column flex w-full py-6 xl:flex-row',
        headingContainer: 'max-w-[327px] md:max-w-[560px] lg:max-w-[560px]',
        heading: [h1({ type: 'primary' }), 'text-center xl:text-left'],
        subheading: 'text-center text-ui-dark/70 lg:mb-0 xl:text-left',
        // aspect ratio for the video is 48/65
        supportingContentContainer:
          // in small screens: less than width 528px = 480px (max video width) + 48px(padding-x)
          //  > height = fullvw - my+py * 1/aspect ratio (dynamic)
          // in screens larger than width 528px = 480px (max video width) + 48px (padding-x)
          //  > height = 650px fixed
          // in screens larger than 1024px
          //  > height = 696px  margin-y + padding-y + 650px fixed width
          'm-auto h-[calc((100vw-48px)*65/48)] min-[528px]:h-[650px] lg:h-[696px] lg:pt-12',
      },
      usp: {
        container: 'w-full grid-cols-1 justify-items-center',
        headingContainer: 'max-w-[327px] md:max-w-[1180px] lg:px-[120px]',
        heading: [h2({ type: 'primary' }), 'text-center md:px-[150px] lg:px-[40px] xl:px-[100px]'],
        subheading:
          'text-center text-ui-dark/70 md:mb-12 md:px-[200px] lg:px-[100px] xl:px-[200px]',
        supportingContentContainer: 'w-full',
      },
      cover: {
        container: 'w-full grid-cols-1 justify-items-center',
        headingContainer: 'max-w-[327px] md:max-w-[1200px] lg:px-[120px]',
        heading: [h2({ type: 'primary' }), 'text-center md:px-[150px] lg:px-[40px] xl:px-[100px]'],
        subheading:
          'text-center text-ui-dark/70 md:mb-12 md:px-[200px] lg:px-[100px] xl:px-[200px]',
        supportingContentContainer: 'w-full',
      },
      faq: {
        container: 'w-full grid-cols-1 justify-items-center',
        headingContainer: 'max-w-[327px] md:max-w-[1200px] lg:px-[120px]',
        heading: [h2({ type: 'primary' }), 'text-center md:px-[150px] lg:px-[40px] xl:px-[100px]'],
        subheading:
          'text-center text-ui-dark/70 md:mb-12 md:px-[200px] lg:px-[100px] xl:px-[200px]',
        supportingContentContainer: 'w-full',
      },
      productsCarousel: {
        container: 'mb-0 w-full grid-cols-1 justify-items-center max-md:pr-0 lg:mb-0',
        headingContainer: 'max-w-[327px] max-md:pr-6 md:max-w-[1200px] lg:px-[120px]',
        heading: [h2({ type: 'primary' }), 'text-center md:px-[150px] lg:px-[40px] xl:px-[100px]'],
        subheading:
          'text-center text-ui-dark/70 md:mb-12 md:px-[200px] lg:px-[100px] xl:px-[200px]',
        supportingContentContainer: 'mb-20 w-full max-w-[1440px] lg:mb-[120px]',
      },
    },
    hyphenatedSubheading: {
      true: {
        subheading: 'typography-balance',
      },
    },
    hyphenatedHeading: {
      true: {
        heading: 'typography-balance',
      },
    },
  },
})
